<template>
    <article class="ParenthesisPost-MAIN">
        <div>
            <p class="post-headline3">{{ postObj.headline3 }}</p>
            <p class="post-title">{{ postObj.title }}</p>
            <p class="post-subtitle">{{ formatDate(postObj.date) }}</p>
        </div>

        <div class="post-slider hide-scrollbar" ref="slider" @scroll="onScroll">
            <div v-for="(block, index) in postObj.preview"  :key="index" class="slide">
                <img v-if="block.type === 'img'" :src="`${$ENDPOINT}/assets/post/${block.content}`"/>
                <div v-if="block.type === 'txt'" class="slide-text">
                    {{ block.content }}
                </div>
            </div>
        </div>

        <div class="post-dots" v-if="postObj.preview && postObj.preview.length > 1">
            <div v-for="(block, index) in postObj.preview" :key="index" :class="{ 'current-post-dot': currentSlide === index }"></div>
        </div>
    </article>
</template>

<script>
export default {
    name: 'ParenthesisPost',
    props: {
        postObj: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            currentSlide: 0,
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '';

            const parts = date.split('-');

            if (parts.length !== 3) return date;

            return `${parts[2]}.${parts[1]}.${parts[0]}`;
        },

        onScroll() {
            const slider = this.$refs.slider;
            if (!slider) return;

            const width = slider.clientWidth;
            if (!width) return;

            this.currentSlide = Math.round(slider.scrollLeft / width);
        },
    }
}
</script>

<style scoped lang="stylus">
.ParenthesisPost-MAIN
    background-color: white
    color: black
    margin: 4vw
    margin-top: 4vw
    border-radius: 5vw
    position: relative
    overflow: hidden

    >div:first-child
        padding: 25px 20px

        >p
            margin: 0
            font-family: "Archivo ExtraCondensed", sans-serif

        .post-headline3
            font-family: "DM Mono", monospace
            font-size: 4vw

        .post-title
            font-size: 7vw
            margin: 5px 0
            font-weight: 600

        .post-subtitle
            font-size: 5vw

    >.post-slider
        width: 100%
        aspect-ratio: 1/1
        display: flex
        overflow-x: auto
        overflow-y: hidden
        scroll-snap-type: x mandatory
        scroll-behavior: smooth
        -webkit-overflow-scrolling: touch
        overscroll-behavior-x: contain

        >.slide
            flex: 0 0 100%
            width: 100%
            min-width: 100%
            height: 100%
            aspect-ratio: 1/1
            scroll-snap-align: center
            scroll-snap-stop: always
            display: flex
            align-items: center
            justify-content: center
            box-sizing: border-box

            >img
                width: 100%
                height: 100%
                object-fit: cover
                object-position: center

            >div
                display: flex
                flex-direction: column
                justify-content: flex-end
                font-family: "Archivo ExtraCondensed regular", sans-serif
                font-size: 4vw
                line-height: 1
                margin: 0
                width: calc(100% - 40px)
                height: calc(100% - 40px)
                aspect-ratio: 1/1
                padding: 20px
                scale: 0.99
                text-align: bottom

        .slide-text
            white-space: pre-line

    .post-dots
        display: flex
        align-items: center
        justify-content: space-evenly
        position: absolute
        bottom: 10px
        left: 0
        right: 0
        margin: 0 auto
        width: 50%

        >div
            width: 5px
            height: 5px
            background-color: lightgray
            border-radius: 100vw

        .current-post-dot
            background-color: #015aff !important
</style>